module.exports = __webpack_public_path__ + "static/media/eca.152afe87.svg";